<header class="header">
  <div class="header__main header__main--{{ type }}">
    <div class="header__content">
      <div class="header__mobile">
        <button class="header__hamburger" type="button" (click)="toggleMobileMenu(true)">{{ 'header.menu' | translate }}</button>
      </div>
      <div class="header__left">
        <a class="header__logo" [routerLink]="globals.routes()['homepage'].url">
          <app-icon [icon]="'logo'" [height]="32">{{ 'globals.webTitle' | translate }}</app-icon>
        </a>
      </div>
      <ul class="header__menu">
        @for (item of navigationService.navigation(); track $index) {
          @if (item.header) {
            <li class="header__menu-item">
              <app-underline-link class="header__menu-link" [route]="item.route | link: 'route'" [href]="item.route | link: 'href'" [target]="(item.route | link: 'href') ? '_blank' : undefined" [line-color]="'primary'">{{ item.title }}</app-underline-link>
            </li>
          }
        }
      </ul>
      <div class="header__right">
        <a class="header__phone" [href]="'tel:' + ('globals.contactData.phone' | translate | phone: false : true)">
          <app-icon class="header__phone-icon" [icon]="'phone'" [height]="24">{{ 'forms.phone' | translate }}</app-icon>
          <span class="header__phone-text">{{ 'globals.contactData.phone' | translate }}</span>
        </a>
      </div>
    </div>
  </div>

  @if (mobileMenuOpen) {
    <div class="header__mobile-menu" [@opacity]>
      <div class="header__mobile-main">
        <div class="header__mobile-menu-header">
          <button class="header__mobile-menu-close" type="button" (click)="toggleMobileMenu(false)">
            <app-icon [icon]="'close'" [width]="24"></app-icon>
          </button>
        </div>
        <ul class="header__mobile-menu-list">
          @for (item of navigationService.navigation(); track $index) {
            @if (item.header) {
              <li class="header__mobile-menu-item">
                @if (item.route | link: 'href') {
                  <a class="header__mobile-menu-link" [href]="item.route | link: 'href'" [target]="'_blank'" (click)="toggleMobileMenu(false)">
                    {{ item.title }}
                    <app-icon [icon]="'arrow-thin'" [width]="24"></app-icon>
                  </a>
                } @else {
                  <a class="header__mobile-menu-link" [routerLink]="item.route | link: 'route'" (click)="toggleMobileMenu(false)">
                    {{ item.title }}
                    <app-icon [icon]="'arrow-thin'" [width]="24"></app-icon>
                  </a>
                }
              </li>
            }
          }
        </ul>
      </div>
      <ul class="header__mobile-menu-socials">
        <li>
          <a class="header__mobile-menu-socials-link" [href]="'globals.contactData.facebook' | translate" target="_blank"><app-icon [icon]="'facebook'" [width]="32">Facebook</app-icon></a>
        </li>
        <li>
          <a class="header__mobile-menu-socials-link" [href]="'globals.contactData.instagram' | translate" target="_blank"><app-icon [icon]="'instagram'" [width]="32">Instagram</app-icon></a>
        </li>
      </ul>
      <div class="header__mobile-menu-bottom">
        <div class="header__mobile-menu-buttons">
          <app-button class="header__mobile-menu-buttons-item" [fullsize]="true" [color]="'light'" [outlined]="true" [outline-width]="'thin'" [app-modal]="'car-demand-modal'" (clicked)="toggleMobileMenu(false)">{{ 'header.requestCar' | translate }}</app-button>
          <app-button class="header__mobile-menu-buttons-item" [route]="globals.routes()['list'].url" [fullsize]="true" (clicked)="toggleMobileMenu(false)">{{ 'globals.showCars' | translate }}</app-button>
        </div>
      </div>
    </div>
  }
</header>
